import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
// import Pagination from "./../../components/Pagination"; // not needed now
import Footer from "../../components/Footer";
import { Styles } from "./styles/blog.js";
import axios from "axios";
// import { Styles } from "./styles/pagination.js";
import { Constant, imageDomain } from "../../helper/Constants.js";

class BlogGrid extends Component {
  state = {
    blogs: [],
    loading: true,
    error: null,
    page: 1,
    limit: 3,
    totalPages: 1,
    totalDocs: 0,
  };

  componentDidMount() {
    const { page, limit } = this.state;
    this.fetchBlogs(page, limit);
  }

  fetchBlogs = async (page = 1, limit = 8) => {
    this.setState({ loading: true, error: null });

    try {
      const baseUrl =
        (Constant && Constant.getUrls && Constant.getUrls.getAllBlogs) ||
        "/api/blogs/list-web";

      const resp = await axios.get(`${baseUrl}?page=${page}&limit=${limit}`);

      // Backend: { status, message, data, pagination }
      const dataWrapper = resp?.data || {};
      const payload = dataWrapper.data ?? [];
      const pagination = dataWrapper.pagination || payload.pagination || {};

      const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload.docs)
          ? payload.docs
          : [];

      const totalDocs =
        pagination.totalDocs ||
        pagination.total ||
        payload.totalDocs ||
        list.length ||
        0;

      const totalPages =
        pagination.totalPages ||
        pagination.totalpage ||
        (limit ? Math.ceil(totalDocs / limit) : 1);

      this.setState({
        blogs: list,
        loading: false,
        error: null,
        page: pagination.page || page,
        limit: pagination.limit || limit,
        totalPages: totalPages || 1,
        totalDocs,
      });
    } catch (err) {
      console.error("Failed to fetch blogs:", err);
      this.setState({
        blogs: [],
        loading: false,
        error:
          err?.response?.data?.message ||
          err.message ||
          "Failed to fetch blogs",
      });
    }
  };

  handlePageChange = (newPage) => {
    const { totalPages, limit } = this.state;
    if (newPage < 1 || newPage > totalPages) return;
    this.fetchBlogs(newPage, limit);
  };

  // Build safe image url
  getImageUrl = (poster) => {
    if (!poster)
      return process.env.PUBLIC_URL + "/assets/images/default-blog.jpg";
    if (/^https?:\/\//i.test(poster)) return poster;
    if (imageDomain)
      return imageDomain.replace(/\/+$/, "") + "/" + poster.replace(/^\/+/, "");
    return (
      (process.env.PUBLIC_URL || "") +
      (poster.startsWith("/") ? poster : "/" + poster)
    );
  };

  // Build blog link (slug preferred)
  getBlogLink = (data) => {
    const slug = data?.slug || data?.id || data?._id;
    if (!slug) return process.env.PUBLIC_URL || "/";
    const path = `/blog-details/${slug}`;
    return (process.env.PUBLIC_URL || "") + path;
  };

  // Format short date like "3 Mar"
  formatShortDate = (data) => {
    const possibleFields = [
      "created_at",
      "published_at",
      "createdAt",
      "blogs_date",
      "date",
      "publish_date",
    ];
    let raw = null;
    for (const f of possibleFields) {
      if (data[f]) {
        raw = data[f];
        break;
      }
    }
    if (!raw) return "";
    const d = new Date(raw);
    if (isNaN(d.getTime())) return "";
    const day = d.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${day} ${monthNames[d.getMonth()]}`;
  };

  // Strip HTML and return up to 200 chars
  getShortContent = (htmlContent) => {
    if (!htmlContent) return "";
    const text = htmlContent.replace(/<[^>]*>?/gm, "");
    return text.length > 200 ? text.substring(0, 200) + "..." : text;
  };

  render() {
    const { blogs, loading, error, page, totalPages } = this.state;

    return (
      <Styles>
        {/* Main Wrapper */}
        <div className="main-wrapper blog-grid-page">
          {/* Header */}
          <Header />

          {/* Breadcrumb */}
          <BreadcrumbBox title="Blog Grid" />

          {/* Blog Grid */}
          <section className="blog-grid-area">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="align-items-stretch">
                    {loading ? (
                      <Col md="12" className="text-center">
                        <p>Loading...</p>
                      </Col>
                    ) : error ? (
                      <Col md="12" className="text-center">
                        <p style={{ color: "red" }}>{error}</p>
                      </Col>
                    ) : blogs.length === 0 ? (
                      <Col md="12" className="text-center">
                        <p>No blogs found.</p>
                      </Col>
                    ) : (
                      blogs.map((data, i) => (
                        <Col
                          xs="12"
                          md="6"
                          lg="4"
                          key={data?.id || data?._id || data?.slug || i}
                          className="d-flex"
                        >
                          <div className="blog-item w-100">
                            <div className="blog-img">
                              <Link to={`/blog-details/${data.slug}`}>
                                <img
                                  src={this.getImageUrl(
                                    data?.blogs_poster ||
                                      data?.poster ||
                                      data?.postImg,
                                  )}
                                  alt={
                                    data?.blogs_title ||
                                    data?.title ||
                                    "blog image"
                                  }
                                  className="img-fluid"
                                />
                              </Link>
                            </div>

                            <div className="blog-content">
                              <div className="blog-auth_date d-flex">
                                <div className="author-img d-flex">
                                  <p>
                                    <Link
                                      to={
                                        process.env.PUBLIC_URL +
                                        (data?.authorLink || "/")
                                      }
                                    >
                                      {data?.authorName ||
                                        data?.author?.name ||
                                        "Author"}
                                    </Link>
                                  </p>
                                </div>
                                <div className="post-date">
                                  <p>
                                    <i className="las la-calendar"></i>{" "}
                                    {this.formatShortDate(data)}
                                  </p>
                                </div>
                              </div>

                              <div className="blog-title">
                                <h6>
                                  <Link to={this.getBlogLink(data)}>
                                    {data?.blogs_title ||
                                      data?.title ||
                                      "Untitled"}
                                  </Link>
                                </h6>
                              </div>

                              <div className="blog-desc">
                                <p>
                                  {this.getShortContent(
                                    data?.blog_content ||
                                      data?.content ||
                                      data?.postDesc,
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))
                    )}
                  </Row>

                  {/* Pagination Controls */}
                  {/* Modern Number Pagination */}

                  {/* Pagination */}
                  {!loading && totalPages > 1 && (
                    <div className="text-center mt-4">
                      <ul className="pagination-box list-unstyled list-inline">
                        {/* First Page */}
                        <li className="list-inline-item">
                          <a
                            onClick={() => this.handlePageChange(1)}
                            style={{
                              cursor: page > 1 ? "pointer" : "not-allowed",
                            }}
                          >
                            <i className="las la-angle-double-left"></i>
                          </a>
                        </li>

                        {/* Page Numbers */}
                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                          .filter((p) => {
                            if (p === 1 || p === totalPages) return true;
                            if (Math.abs(p - page) <= 2) return true;
                            return false;
                          })
                          .map((p, index, arr) => {
                            const prev = arr[index - 1];
                            const gap = prev && p - prev > 1;

                            return (
                              <React.Fragment key={p}>
                                {/* Dots */}
                                {gap && (
                                  <li className="list-inline-item">
                                    <a
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                      }}
                                    >
                                      ...
                                    </a>
                                  </li>
                                )}

                                {/* Page Button */}
                                <li
                                  className={`list-inline-item ${
                                    page === p ? "active" : ""
                                  }`}
                                >
                                  <a
                                    onClick={() => this.handlePageChange(p)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {p}
                                  </a>
                                </li>
                              </React.Fragment>
                            );
                          })}

                        {/* Last Page */}
                        <li className="list-inline-item">
                          <a
                            onClick={() => this.handlePageChange(totalPages)}
                            style={{
                              cursor:
                                page < totalPages ? "pointer" : "not-allowed",
                            }}
                          >
                            <i className="las la-angle-double-right"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
                </Col>

                {/* Right column kept empty (no sidebar) */}
                <Col lg="3" md="4" sm="12"></Col>
              </Row>
            </Container>
          </section>

          {/* Footer */}
          <Footer />
        </div>
      </Styles>
    );
  }
}

export default BlogGrid;
